import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";
import { cloneDeep, cloneDeepWith } from "lodash";
import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../common_components/mdae-framework";
const initialError = {
  code: "",
  message: "",
  value: [],
};
const initialState = {
  auditViewUserTaskListConfig: {},
};
export const TOGGLE_CARD_VIEW_SWITCH = "TOGGLE_CARD_VIEW_SWITCH";
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      return state;
    case TOGGLE_CARD_VIEW_SWITCH:
      newState = cloneDeep(state);
      let auditViewUserTaskListConfig =
        newState.auditViewUserTaskListConfig[action.data.myTaskWidgetId];
      auditViewUserTaskListConfig = auditViewUserTaskListConfig
        ? auditViewUserTaskListConfig
        : {};
      for (var prop in action.data) {
        auditViewUserTaskListConfig[prop] = action.data[prop];
      }
      newState.auditViewUserTaskListConfig[
        action.data.myTaskWidgetId
      ] = auditViewUserTaskListConfig;
      return newState;
    default:
      return state;
  }
};
